import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gtr-win w-100 position-relative"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "card-title-row" }
const _hoisted_4 = { class: "card-background d-flex flex-column position-relative h-100" }
const _hoisted_5 = { class: "card-body d-flex flex-column flex-grow-1 position-relative" }
const _hoisted_6 = { class: "card-subtitle text-center" }
const _hoisted_7 = {
  key: 0,
  class: "includes-banner text-center text-uppercase"
}
const _hoisted_8 = { class: "benefits text-white" }
const _hoisted_9 = { class: "section-title" }
const _hoisted_10 = { class: "list-unstyled" }
const _hoisted_11 = {
  key: 0,
  class: "item-note"
}
const _hoisted_12 = {
  key: 0,
  class: "benefit-section"
}
const _hoisted_13 = { class: "section-title" }
const _hoisted_14 = { class: "list-unstyled also-includes" }
const _hoisted_15 = {
  key: 0,
  class: "item-note"
}
const _hoisted_16 = { class: "card-footer position-relative text-white text-center lh-1" }
const _hoisted_17 = { class: "initial-price text-nowrap" }
const _hoisted_18 = { class: "text-nowrap" }
const _hoisted_19 = { class: "text-end me-5" }
const _hoisted_20 = { class: "monthly-price" }
const _hoisted_21 = {
  key: 0,
  class: "card-action d-flex position-relative justify-content-center mt-4"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "background-border" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_package_icon, { product: "gtr-win" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.SubscriptionConfig.displayName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Benefits.subtitle), 1),
            (_ctx.Benefits.includesBanner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.Benefits.includesBanner), 1))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-body-title text-center" }, "Beneficios", -1)),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Benefits.sections, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: section.title,
                  class: "benefit-section"
                }, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(section.title), 1),
                  _createElementVNode("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.n
                      }, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", {
                          class: "fa fa-circle fa-xs me-1",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(item.text) + " ", 1),
                        (item.note)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(" + _toDisplayString(item.note) + ")", 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128)),
              (_ctx.Benefits.alsoIncludes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.Benefits.alsoIncludes.title), 1),
                    _createElementVNode("ul", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Benefits.alsoIncludes.items, (extra) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: extra.text
                        }, [
                          _cache[2] || (_cache[2] = _createElementVNode("i", {
                            class: "fa fa-circle fa-xs me-1",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(extra.text) + " ", 1),
                          (extra.note)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "(" + _toDisplayString(extra.note) + ")", 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "card-footer-title" }, "Inicial", -1)),
              _cache[5] || (_cache[5] = _createTextVNode("  ", -1)),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.SubscriptionConfig.cost) + " " + _toDisplayString(_ctx.SubscriptionConfig.currency), 1),
              _createElementVNode("span", _hoisted_18, " / " + _toDisplayString(_ctx.SubscriptionConfig.duration) + " " + _toDisplayString(_ctx.SubscriptionDurationUnitLocalized), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.SubscriptionConfig.renewalCost) + " " + _toDisplayString(_ctx.SubscriptionConfig.currency), 1),
              _cache[6] || (_cache[6] = _createTextVNode("  ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "period-label" }, "Mensuales", -1))
            ])
          ]),
          (!_ctx.isOffline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "btn btn-light btn-lg gtr-win-btn",
                  type: "button",
                  disabled: _ctx.isQuoting,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subscriptionQuote()))
                }, [
                  _cache[8] || (_cache[8] = _createTextVNode("Inscribirse ", -1)),
                  (_ctx.isQuoting)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_22)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}